import {UI} from "../../../../../stem-core/ui/UIBase";
import {DateCalendarMonthInputInterface} from "../base/DateCalendarMonthInputInterface";
import {DateCalendarDay} from "./DateCalendarDay";
import type {StemDate} from "../../../../../stem-core/time/Date";


export class DateCalendarMonthInput extends DateCalendarMonthInputInterface {
    renderDayElement(date: StemDate) {
        const {monthDate, minDate, maxDate} = this.options;

        return <DateCalendarDay date={date} hoverDate={this.hoverDate} onHover={date => this.onDateHover(date)}
                                onSelect={date => this.onDateSelection(date)}
                                selectedDate={this.value} monthDate={monthDate}
                                minDate={minDate} maxDate={maxDate}/>
    }

    onDateSelection(date: StemDate) {
        this.setAndDispatchValue(date);
    }
}
